import { z } from "zod"
import { defineOperationContext } from "../define"
import type { ProductsDetectMetadataInput } from "../schemas/products-detect-metadata"

export const productsDetectMetadataContextSchema = z.object({
	productCount: z.number().int().nonnegative(),
})

export type ProductsDetectMetadataContext = z.infer<
	typeof productsDetectMetadataContextSchema
>

export const productsDetectMetadataContextSpec = defineOperationContext<
	ProductsDetectMetadataInput,
	ProductsDetectMetadataContext
>({
	version: 1,
	schema: productsDetectMetadataContextSchema,
	fromInput: (input) => ({
		productCount: input.products.length,
	}),
})
